/**
 * FIN-8016: regra única de quando mostrar o contador.
 * FIN-8011 (D17): o contador só aparece quando faltam até
 * `urgencyTimeThresholdMinutes` minutos para o fim das vendas (configurado no
 * plano da oferta; null = mostra o tempo todo).
 */
export const OFFER_DISPLAY_RULES = {
  countdownEnabled: true,
};

export type OfferDisplayRules = typeof OFFER_DISPLAY_RULES;

const MS_PER_MINUTE = 60 * 1000;

export function shouldShowCountdown(
  remainingMs: number | null,
  thresholdMinutes?: number | null,
  rules: OfferDisplayRules = OFFER_DISPLAY_RULES
): boolean {
  if (!rules.countdownEnabled) return false;
  if (remainingMs === null || remainingMs <= 0) return false;
  if (thresholdMinutes === null || thresholdMinutes === undefined) return true;

  return remainingMs <= thresholdMinutes * MS_PER_MINUTE;
}

/**
 * FIN-8239: regra única de quando mostrar as vagas restantes.
 * Esconde sem vagas informadas (productSales null / remainingSlots null) ou
 * com as vagas esgotadas (<= 0, a tela de esgotado é outra frente). O limiar
 * `urgencySalesThreshold` funciona como o do contador: null/undefined mostra
 * sempre, 0 nunca, N só quando restam até N vagas.
 */
export function shouldShowRemainingSlots(
  remainingSlots: number | null | undefined,
  urgencySalesThreshold?: number | null
): boolean {
  if (remainingSlots === null || remainingSlots === undefined) return false;
  if (remainingSlots <= 0) return false;
  if (urgencySalesThreshold === null || urgencySalesThreshold === undefined) {
    return true;
  }

  return remainingSlots <= urgencySalesThreshold;
}
